import { buildQuickview } from "@coveo/headless";
import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import Modal from './Modal';
import DownloadBtn from "./DownloadBtn";
const SelectBtn:FunctionComponent<any> = function ({item}) {
    console.log("render");
    const [isSelected, setIsSelected] = useState<boolean>(false);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [isShowPopupContent, setIsShowPopupContent] = useState<boolean>(false);
    let renditionUrl = "https://www.usa.canon.com/nw3s" + item.rendition_url;
    const eventSelected = async (e: any) => {
        e.preventDefault();
        if (isLoaded) {
            setIsSelected(true);
            return;
        }
        let href = e.currentTarget.href;
        try {
            await axios.get(window.location.origin + '/bin/canon/downloadFiles.urlChecker.json', {
                params: {
                    'renditionUrl': renditionUrl,
                    '_': new Date().getTime()
                }
            }).then((res)=>{
                // @ts-ignore
                if(res.status == 200 && res.data) {
                    setIsSelected(true);
                    if(!isSelected){
                        setIsLoaded(true);
                        setIsShowPopupContent(true);
                    }
                }
            });
        } catch (error) {
            console.error('Error fetching content:', error);
        }
    }
    // TODO: remove data_mock
    return (<div className={isSelected ? "select__cta rightSection btn-selected" : "select__cta rightSection"}>
        {isShowPopupContent && (
            <div className="wcmUtilitySurvey">
                <button className="survey-close-btn" onClick={() => {
                    setIsShowPopupContent(false)
                }}></button>
                <iframe className="wcmSurveyIframe" src="https://canonusa.allegiancetech.com/cgi-bin/qwebcorporate.dll?WM9BXV"></iframe>
            </div>
        )}
        <div className="cta-btn-container btn-selected-container">
            <div className="outlined-btn-wrapper">
                <div onClick={eventSelected} role="button" className={isSelected ? "btn select-btn btn-primary btn-common outlined-button selected" : "btn select-btn btn-primary btn-common outlined-button"}>
                    <span className="select__cta-label">{isSelected ? "SELECTED" : "SELECT" }</span>
                    <span className="checked-icon"></span>
                </div>
            </div>
        </div>
        {isSelected && (<DownloadBtn item={item} ></DownloadBtn>)}
    </div>);
}
export default SelectBtn;